module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-01-grey.9270b7e1.svg";